import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import  DataMigrationConfig  from "../util/dataMigrationConfig"
import { GETMIGRATIONDEFAULTOBJECT_REQ, GETMIGRATIONOBJECTVALIDATE_REQ,GETMIGRATIONDETAILS_REQ, GETMIGRATIONSTART_REQ, GETMIGRATIONSTATUSLIST_REQ } from "../../../../actions";
import { Popup } from "../../../../../src/components/pop-up";
import * as actions from "../../../../../src/actions/index";

export default function ModuleSelected({ setStep, formik, setCurrentMigID, isReadOnlyView, currentMigID, setselectedConfigFields }) {

  const migrationDefaultObject = useSelector((state) => state?.migration?.migration_default_object);
  const validationResult = useSelector((state) => state?.migration?.migration_validation_result);
  const migrationStartResult = useSelector((state) => state?.migration?.migration_start_result);
  const migrationStatusResult = useSelector((state) => state?.migration?.migration_status_list);
  const migrationDetails = useSelector((state) => state?.migration?.details);
  
  const urlParams = useRef({});
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState();
  const [selectedDataConfigFields, setselectedDataConfigFields] = useState([])
  const [dependencyList, setDependencyList] = useState([])
  const [isValidationMaded, setisValidationMaded] = useState(false)
  const [migrationObjectArray, setMigrationDefaultObject] = useState(migrationDefaultObject.data)
  const [currentTabIndex, setcurrentTabIndex] = useState([]);
  const [ sourceAccountConfig, setSourceAccountConfig] = useState(migrationDefaultObject.sourceAccountConfig)
  const [selectedCategoryCount, setselectedCategoryCount] = useState(0);
  const [dependentDataLookup, setDependentDataLookup] = useState({});


  useEffect(() => {
    if (currentMigID) {
      dispatch(GETMIGRATIONSTATUSLIST_REQ({ "migrationID": currentMigID }));
    }
    dispatch(GETMIGRATIONDEFAULTOBJECT_REQ());
  }, []);
  console.log("formik.values.isDataMigrationEnabled",formik.values)
  useEffect(() => {
    if (!isReadOnlyView) {
      setMigrationDefaultObject(migrationDefaultObject.data)
    }
    if(formik.values.isFromSourceAccount && migrationDefaultObject && migrationDefaultObject.data &&migrationDefaultObject.data.length > 0) {
      setMigrationDefaultObject(migrationDefaultObject.data)
      setselectedDataConfigFields(migrationDefaultObject.data)

    }
  }, [migrationDefaultObject]);

    useEffect(() => {
          if (currentMigID) {
              urlParams.current.id = currentMigID;
              dispatch(GETMIGRATIONDETAILS_REQ(urlParams.current));
          }
      }, [currentMigID]);

  useEffect(() => {
    if (isReadOnlyView) {
      let specialParent = ['GENERALSETTINGS', 'CONFIGURATIONSETTINGS'];

      for (let c = 0; c < migrationStatusResult.data.length; c++) {
        let index = migrationObjectArray.findIndex(object => object.module == migrationStatusResult.data[c].config_module)
        if (index != -1) {
          if (migrationObjectArray[index].child.length > 0) {
            let childIndex = migrationObjectArray[index].child.findIndex(object => object.module == migrationStatusResult.data[c].config_name)
            if (childIndex != -1) {
              migrationObjectArray[index].child[childIndex].checked = true
              const element = document.getElementById("comments_" + index)
              if (element) {
                document.getElementById("comments_" + index).indeterminate = true
              }
            }
          }
          let isAllChildChecked = migrationObjectArray[index].child.filter((obj) => obj.checked)
          if (isAllChildChecked.length == migrationObjectArray[index].child.length) {
            migrationObjectArray[index].checked = true
              const element = document.getElementById("comments_" + index)
              if (element) {
                document.getElementById("comments_" + index).indeterminate = false
              }
          }
        }
        else {
          for (let s = 0; s < specialParent.length; s++) {
            let index = migrationObjectArray.findIndex(object => object.module == specialParent[s])
            if (index != -1) {
              if (migrationObjectArray[index].child.length > 0) {
                let childIndex = migrationObjectArray[index].child.findIndex(object => object.module == migrationStatusResult.data[c].config_module)
                if (childIndex != -1) {
                  migrationObjectArray[index].child[childIndex].checked = true
                  const element = document.getElementById("comments_" + index)
                  if (element) {
                    document.getElementById("comments_" + index).indeterminate = true
                  }
                 
                }
              }
              let isAllChildChecked = migrationObjectArray[index].child.filter((obj) => obj.checked)
              if (isAllChildChecked.length == migrationObjectArray[index].child.length) {
                migrationObjectArray[index].checked = true
                  const element = document.getElementById("comments_" + index)
                  if (element) {
                    document.getElementById("comments_" + index).indeterminate = false
                  }
              }
            }
          }
        }
      }
      setMigrationDefaultObject([...migrationObjectArray])
    }
  }, [isReadOnlyView])

  useEffect(() => {
    if (formik.values.isDataMigrationEnabled && formik.values.isFromSourceAccount && migrationObjectArray && migrationObjectArray.length > 0) {
      setselectedCategoryCount(20)
      let specialParent = ['GENERALSETTINGS', 'CONFIGURATIONSETTINGS'];
      for (let c = 0; c < sourceAccountConfig.data.length; c++) {
        let index = migrationObjectArray.findIndex(object => object.module === sourceAccountConfig.data[c].config_module)
        if (index !== -1) {
          if (migrationObjectArray[index].child.length > 0) {
            let childIndex = migrationObjectArray[index].child.findIndex(object => object.module === sourceAccountConfig.data[c].config_name)
            if (childIndex !== -1) {
              migrationObjectArray[index].child[childIndex].checked = true
              migrationObjectArray[index].child[childIndex].dependency?.forEach((dependecy) => {
                if (dependecy.parentModule !== 'DEPENDENT_DATA') return; // skip non dependent data module
                let from = { parentModule: migrationObjectArray[index].module, childModule: migrationObjectArray[index].child[childIndex].module, parentName: migrationObjectArray[index].name, childName: migrationObjectArray[index].child[childIndex].name }
                updateChildMigrationDependecy(from, { ...dependecy, value: true })
              })
              const element = document.getElementById("comments_" + index)
              if (element) {
                document.getElementById("comments_" + index).indeterminate = true
              }

            }
          }
          let isAllChildChecked = migrationObjectArray[index].child.filter((obj) => obj.checked)
          if (isAllChildChecked.length === migrationObjectArray[index].child.length) {
            migrationObjectArray[index].checked = true
            const element = document.getElementById("comments_" + index)
            if (element) {
              document.getElementById("comments_" + index).indeterminate = false
            }
          }
        }
        else {
          for (let s = 0; s < specialParent.length; s++) {
            let index = migrationObjectArray.findIndex(object => object.module === specialParent[s])
            if (index !== -1) {
              if (migrationObjectArray[index].child.length > 0) {
                let childIndex = migrationObjectArray[index].child.findIndex(object => object.module === sourceAccountConfig.data[c].config_module)
                if (childIndex !== -1) {
                  migrationObjectArray[index].child[childIndex].checked = true
                  migrationObjectArray[index].child[childIndex].dependency?.forEach((dependecy) => {
                    if (dependecy.parentModule !== 'DEPENDENT_DATA') return; // skip non dependent data module
                    let from = { parentModule: migrationObjectArray[index].module, childModule: migrationObjectArray[index].child[childIndex].module, parentName: migrationObjectArray[index].name, childName: migrationObjectArray[index].child[childIndex].name }
                    updateChildMigrationDependecy(from, { ...dependecy, value: true })
                  })
                  const element = document.getElementById("comments_" + index)
                  if (element) {
                    document.getElementById("comments_" + index).indeterminate = true
                  }
                }
              }
              let isAllChildChecked = migrationObjectArray[index].child.filter((obj) => obj.checked)
              if (isAllChildChecked.length === migrationObjectArray[index].child.length) {
                migrationObjectArray[index].checked = true
                const element = document.getElementById("comments_" + index)
                if (element) {
                  document.getElementById("comments_" + index).indeterminate = false
                }
              }
            }
          }
        }
      }
      setMigrationDefaultObject([...migrationObjectArray])
    }
  }, [formik.values.isFromSourceAccount, selectedDataConfigFields])

  useEffect(() => {
    if (isValidationMaded) {
      if (validationResult?.data?.modules.length > 0) {
        let currentMigrationObjectArray = [...migrationObjectArray]
         for(let valIdx = 0 ; valIdx < validationResult.data.modules.length ; valIdx++ )   
            {
               for(let currentIdx = 0 ; currentIdx < currentMigrationObjectArray.length ; currentIdx++){ 
                 
                  if(currentMigrationObjectArray[currentIdx].module == validationResult.data.modules[valIdx].config_module )
                      {
                        currentMigrationObjectArray[currentIdx].isRequired = true;
                          if( currentMigrationObjectArray[currentIdx].child?.length > 0 )
                            {
                                  for(let childIdx = 0 ; childIdx < currentMigrationObjectArray[currentIdx].child.length ; childIdx++) 
                                  {
                                    if(currentMigrationObjectArray[currentIdx]?.child[childIdx]?.module == validationResult.data.modules[valIdx].config_name){
                                      currentMigrationObjectArray[currentIdx].child[childIdx].isRequired = true
                                       break;          
                                    }
                                  }
                            }
                            break;
                      }
               }
              }
              setMigrationDefaultObject([...currentMigrationObjectArray])

        setDependencyList(validationResult.data.modules)
        setOpenModal(true)
      }
      else {
        dispatch(GETMIGRATIONSTART_REQ(formik['values']));
      }
    }
  }, [validationResult]);

  useEffect(() => {
    if (migrationStartResult.data && Object.keys(migrationStartResult).length > 0) {
      setselectedConfigFields(formik?.values?.migration_config?.config_migrations ? formik['values']['migration_config']['config_migrations'] : [])
      setStep("configStatus")
      setCurrentMigID(migrationStartResult.data.migrationUID)
      dispatch(actions.RESET_STATE("migration.migration_start_result"));
      dispatch(actions.RESET_STATE("migration.migration_status_list"))
    }
  }, [migrationStartResult]);

  const setParentCurrentTab = (e, index, skip) => {
    if ('comments_' + index === e.target['id'] && !skip) {
      let result = updateParentMigrationObject(index)
      setMigrationDefaultObject([...result])
      return false
    }

    let currentTab = currentTabIndex.indexOf(index)
    if (currentTab > -1) {
      currentTabIndex.splice(currentTab, 1)
      setcurrentTabIndex([...currentTabIndex])
    } else {
      setcurrentTabIndex([...currentTabIndex, index])
    }
  }

  const setChildCurrentTab = (parentIndex, childIndex) => {
    let result = updateChildMigrationObject(parentIndex, childIndex)
    setMigrationDefaultObject([...result])
  }

  const updateParentMigrationObject = (index) => {
    let parent = migrationObjectArray[index]
    let isChecked = !migrationObjectArray[index]?.checked
    isChecked ? setselectedCategoryCount(selectedCategoryCount + 1) : setselectedCategoryCount(selectedCategoryCount - 1) // for "start migration" button
    migrationObjectArray[index].checked = isChecked
    if (migrationObjectArray[index]?.child.length > 0) {
      migrationObjectArray[index].child = migrationObjectArray[index]?.child.map((object) => {
        console.log("object inside parent ", object)
        let result = sourceAccountConfig.data.find((obj) => {
          if (formik.values.isFromSourceAccount && formik.values.isDataMigrationEnabled && obj.config_module === migrationObjectArray[index].module && obj.config_name === object.module) {
            return true;
          }
          return false;
        })
        if (result) {
          object.checked = true
        }
        else {
          object.checked = isChecked
        }
        let from = { parentModule: parent.module, childModule: object.module, parentName: parent.name, childName: object.name }
        object.dependency?.forEach((dependecy) => {
          if (dependecy.parentModule !== 'DEPENDENT_DATA') return; // skip non dependent data module
          updateChildMigrationDependecy(from, { ...dependecy, value: object.checked })
        })
        return object;
      })
    }

    let isAllChildChecked = parent.child.every((obj) => obj.checked)
    parent.checked = isAllChildChecked
    parent.isHaveInterminate = !isAllChildChecked && parent.child.some((obj) => obj.checked);
    let checkboxEle = document.getElementById("comments_" + index)
    if (checkboxEle) checkboxEle.indeterminate = parent.isHaveInterminate

    return migrationObjectArray;
  }

  const updateChildMigrationDependecy = (from, { parentModule, module, value }) => {

    let parent = migrationObjectArray.find((obj) => obj.module === parentModule);
    let child = parent.child.find((obj) => obj.module === module);

    parent.isHaveInterminate = true

    if (value) {
      child.checked = true;
      setDependentDataLookup((lookupData) => {
        if (!lookupData[parentModule]) lookupData[parentModule] = {};
        if (!lookupData[parentModule][module]) lookupData[parentModule][module] = [];
        if (lookupData[parentModule][module].findIndex(item => item.parentModule === from.parentModule && item.childModule === from.childModule) !== -1) return lookupData; // already exist
        lookupData[parentModule][module].push(from);
        return { ...lookupData };
      })
    } else {
      if (!dependentDataLookup[parentModule]?.[module]) return dependentDataLookup;
      dependentDataLookup[parentModule][module] = dependentDataLookup[parentModule]?.[module]?.filter((item) => {
        return item.parentModule !== from.parentModule || item.childModule !== from.childModule
      });
      child.checked = dependentDataLookup[parentModule][module]?.length > 0;
      setDependentDataLookup({ ...dependentDataLookup });
    }
    child.checked ? setselectedCategoryCount(selectedCategoryCount + 1) : setselectedCategoryCount(selectedCategoryCount - 1) // for "start migration" button
    child.isRequired = false;

    let isAllChildChecked = parent.child.every((obj) => obj.checked)
    parent.checked = isAllChildChecked
    parent.isHaveInterminate = !isAllChildChecked && parent.child.some((obj) => obj.checked);
    let checkboxEle = document.getElementById("comments_" + parentModule)
    if (checkboxEle) checkboxEle.indeterminate = parent.isHaveInterminate
    // migrationObjectArray[parentIndex] = parent;

    return migrationObjectArray;
  }

  const updateChildMigrationObject = (parentIndex, childIndex) => {

    let parent = migrationObjectArray[parentIndex]
    let isChecked = !parent?.child[childIndex]?.checked

    sourceAccountConfig.data.forEach((obj) => {
      if (formik.values.isFromSourceAccount && formik.values.isDataMigrationEnabled && obj.config_module === parent.module && obj.config_name === parent.child[childIndex].module) {
        isChecked = true
        toast.error("Data migration is enabled, so this field is required")
      }
    })
    parent.isHaveInterminate = true
    isChecked ? setselectedCategoryCount(selectedCategoryCount + 1) : setselectedCategoryCount(selectedCategoryCount - 1) // for "start migration" button

    parent.child[childIndex].checked = isChecked;
    parent.child[childIndex].isRequired = false;
    let isAllChildChecked = parent.child.filter((obj) => obj.checked)
    if (isAllChildChecked.length === parent.child.length) {
      parent.checked = true
      parent.isHaveInterminate = false
    } else {
      parent.checked = false
      parent.isHaveInterminate = isAllChildChecked.length === 0 ? false : true
    }

    document.getElementById("comments_" + parentIndex).indeterminate = parent.isHaveInterminate


    parent.child[childIndex].dependency?.forEach((dependecy) => {
      if (dependecy.parentModule !== 'DEPENDENT_DATA') return; // skip non dependent data module
      let from = { parentName: parent.name, parentModule: parent.module, childModule: parent.child[childIndex].module, childName: parent.child[childIndex].name }
      updateChildMigrationDependecy(from, { ...dependecy, value: isChecked })
    })
    migrationObjectArray[parentIndex] = parent;
    return migrationObjectArray;
  }

  const validation = () => {

    let finalObject = []
    let ignoreParent = ['GENERALSETTINGS', 'CONFIGURATIONSETTINGS'];

    migrationObjectArray.forEach((config) => {
      if (!config.child || config.child.length <= 0) {
        if (config.checked) {
          finalObject.push({
            config_name: config.module
          })
        }
      } else {
        config.child.forEach((childConfig) => {
          if (childConfig.checked) {
            let temp
            if (ignoreParent.indexOf(config.module) > -1) {
              temp = { config_module: childConfig.module }
            } else {
              temp = {
                config_module: config.module,
                config_name: childConfig.module
              }
            }
            finalObject.push(temp)
          }
        })
      }
    })

    formik['values']['migration_config'] = {
      "config_migrations": finalObject
    };

    dispatch(GETMIGRATIONOBJECTVALIDATE_REQ(formik.values));
    setisValidationMaded(true)
  }
  return (
    <section aria-labelledby="primary-heading" className="flex h-full min-w-0 flex-1 flex-col lg:order-last">
      <div className="h-full">
        <div className="relative h-full w-full overflow-hidden bg-white rounded-lg shadow px-4">
          <div className="p-2">
            <div className="flow-root">
              <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full py-4 align-middle sm:px-6 lg:px-8">
                  <div className="mx-auto pb-3 border-b sm:flex sm:items-center sm:justify-between">
                    <h3 className="text-lg font-semibold leading-6 text-gray-900">
                      Module Selection
                    </h3>
                    <div className="mt-3 sm:ml-4 sm:mt-0">
                      <div className="flex space-x-2">
                        {!isReadOnlyView && <button disabled={(!(selectedCategoryCount > 0))} type="button" onClick={() => validation()}
                          className="relative inline-flex items-center gap-x-1.5 rounded-md bg-gray-800 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-50">
                          Start Migration
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                            strokeWidth="1.5" stroke="currentColor" className="w-4 h-4">
                            <path strokeLinecap="round" strokeLinejoin="round"
                              d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                          </svg>
                        </button>}
                      </div>
                    </div>
                  </div>

                  <div className="mt-4 mb-4 gap-x-6 gap-y-6">
                    <ul>
                      {migrationObjectArray?.filter((obj) => !['DEPENDENT_DATA', 'DATA_MIGRATION'].includes(obj?.module))?.map((parentObject, index) => (
                        <div id="accordion-open" data-accordion="open">
                          <h2 id="accordion-open-heading-1">
                            <button type="button" onClick={(e) => setParentCurrentTab(e, index)}
                              className={`${currentTabIndex.indexOf(index) > -1 ? "bg-gray-100" : ""} flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-b-0 border-gray-200 rounded-t-xl focus:ring-4 focus:ring-gray-200 gap-3`}
                              aria-expanded="true"
                            >
                              <span className="flex items-center text-lg">
                                <input id={"comments_" + index}
                                  aria-describedby="comments-description" name="comments" disabled={isReadOnlyView} type="checkbox" checked={parentObject.checked}  //|| (formik.values.isFromSourceAccount && formik.values.isDataMigrationEnabled)
                                  className={`border-gray-300 h-4 w-4 rounded  text-gray-800 focus:ring-gray-800 mr-3 indeterminate:border-primary ${parentObject.isRequired ? "indeterminate:bg-red-400" : "indeterminate:bg-primary"} indeterminate:after:absolute indeterminate:after:ms-[0.2rem] indeterminate:after:mt-[6px] indeterminate:after:w-[0.5rem] indeterminate:after:border-[0.05rem] indeterminate:after:border-solid indeterminate:after:border-white indeterminate:focus:after:w-[0.5rem] indeterminate:focus:after:rounded-none indeterminate:focus:after:border-[0.125rem] indeterminate:focus:after:border-b-0 indeterminate:focus:after:border-e-0 indeterminate:focus:after:border-s-0 dark:indeterminate:border-primary dark:indeterminate:bg-primary indeterminate:!bg-none`}

                                />
                                <label className={`${parentObject.isRequired === true ? "font-medium text-red-400" : "font-medium text-gray-500"}`}> {parentObject.name}</label></span>
                              <svg data-accordion-icon className={currentTabIndex.indexOf(index) > -1 ? "w-3 h-3 rotate-180 shrink-0" : "w-3 h-3 shrink-0"} aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
                                  strokeWidth="2" d="M9 5 5 1 1 5" />
                              </svg>
                            </button>
                          </h2>
                          <div className={currentTabIndex.indexOf(index) > -1 ? 'open' : 'hidden'} aria-labelledby="accordion-open-heading-1">
                            <div className="px-4 py-5 border border-b-0 border-gray-200">
                              <ul className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                                {parentObject.child.map((childObject, childIndex) => (
                                  (<li className="col-span-1 divide-y divide-gray-200 rounded-lg">
                                    <div className="flex w-full items-center px-6 py-3">
                                      <div className="flex h-6 items-center mr-3">
                                        <input id="child_comments" aria-describedby="child_comments-description" name="child_comments"
                                          type="checkbox" disabled={isReadOnlyView} checked={childObject.checked} onClick={() => setChildCurrentTab(index, childIndex)}   //||  (formik.values.isFromSourceAccount && formik.values.isDataMigrationEnabled)
                                          className={`${childObject.isRequired === true ? "h-4 w-4 rounded border-red-500 text-gray-800 focus:ring-gray-800" : "h-4 w-4 rounded border-gray-300 text-gray-800 focus:ring-gray-800"}`} />
                                      </div>
                                      <div className="ml-1 text-sm leading-6">
                                        <label className={`${childObject.isRequired === true ? "font-medium text-red-500" : "font-medium text-gray-900"}`}>{childObject.name}</label>
                                      </div>
                                    </div>
                                  </li>)
                                ))
                                }
                              </ul>
                            </div>
                          </div>
                        </div>
                      ))
                      }
                      {
                        migrationObjectArray?.filter((obj) => {
                          let migration = isReadOnlyView ? migrationDetails?.data[0]?.isDataMigrationEnabled : formik.values.isDataMigrationEnabled
                          return (migration && ['DATA_MIGRATION'].includes(obj.module)) || (!migration && ['DEPENDENT_DATA'].includes(obj.module))
                        })?.map((parentObject) => (
                          <div id="accordion-open" data-accordion="open">
                            <h2 id="accordion-open-heading-1">
                              <button type="button" onClick={(e) => setParentCurrentTab(e, parentObject.module, true)}
                                className={`${currentTabIndex.indexOf(parentObject.module) > -1 ? "bg-gray-100" : ""} flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-b-0 border-gray-200 rounded-t-xl focus:ring-4 focus:ring-gray-200 gap-3`}
                                aria-expanded="true"
                              >
                                <span className="flex items-center text-lg">
                                  <input id={"comments_" + parentObject.module}
                                    onClick={(event) => {
                                      console.log("stop propagation called")
                                      // event.stopPropagation();
                                      event.preventDefault();
                                    }}
                                    aria-describedby="comments-description" name="comments" disabled={isReadOnlyView} type="checkbox" checked={parentObject.checked}  //|| (formik.values.isFromSourceAccount && formik.values.isDataMigrationEnabled)
                                    className={`border-gray-300 h-4 w-4 rounded  text-gray-800 focus:ring-gray-800 mr-3 indeterminate:border-primary ${parentObject.isRequired ? "indeterminate:bg-red-400" : "indeterminate:bg-primary"} indeterminate:after:absolute indeterminate:after:ms-[0.2rem] indeterminate:after:mt-[6px] indeterminate:after:w-[0.5rem] indeterminate:after:border-[0.05rem] indeterminate:after:border-solid indeterminate:after:border-white indeterminate:focus:after:w-[0.5rem] indeterminate:focus:after:rounded-none indeterminate:focus:after:border-[0.125rem] indeterminate:focus:after:border-b-0 indeterminate:focus:after:border-e-0 indeterminate:focus:after:border-s-0 dark:indeterminate:border-primary dark:indeterminate:bg-primary indeterminate:!bg-none`}

                                  />
                                  <label className={`${parentObject.isRequired === true ? "font-medium text-red-400" : "font-medium text-gray-500"}`}> {parentObject.name}</label></span>
                                <svg data-accordion-icon className={currentTabIndex.indexOf(parentObject.module) > -1 ? "w-3 h-3 rotate-180 shrink-0" : "w-3 h-3 shrink-0"} aria-hidden="true"
                                  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
                                    strokeWidth="2" d="M9 5 5 1 1 5" />
                                </svg>
                              </button>
                            </h2>
                            <div className={currentTabIndex.indexOf(parentObject.module) > -1 ? 'open' : 'hidden'} aria-labelledby="accordion-open-heading-1">
                              <div className="px-4 py-5 border border-b-0 border-gray-200">
                                <ul className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                                  {parentObject.child.map((childObject) => (
                                    (<li className="col-span-1 divide-y divide-gray-200 rounded-lg">
                                      <div className="flex w-full items-center px-6 py-3">
                                        <div className="flex h-6 items-center mr-3">
                                          <input id="child_comments" aria-describedby="child_comments-description" name="child_comments"
                                            type="checkbox" disabled={isReadOnlyView} checked={childObject.checked}
                                            onClick={(event) => {
                                              event.stopPropagation();
                                              event.preventDefault();
                                              if (parentObject.module === 'DATA_MIGRATION') {
                                                toast.error("Data migration is enabled, so this field is required")
                                                return;
                                              }
                                              if (!childObject.checked) {
                                                toast.error(`Please select dependent configurations to include this`);
                                                return;
                                              } else {
                                                let modules = dependentDataLookup[parentObject.module]?.[childObject.module] || [];
                                                let moduleNames = modules.reduce((names, mod) => {
                                                  if (!names[mod.parentName]) names[mod.parentName] = [];
                                                  names[mod.parentName].push(mod.childName);
                                                  return names;
                                                }, {})
                                                toast.error(() => {
                                                  console.log("moduleNames", modules)
                                                  return (
                                                    <>
                                                      <div>{`Following configurations depend on this data:`}</div>
                                                      <ul className="list-disc ml-5 pl-2">
                                                        {Object.keys(moduleNames).map((parentName) => {
                                                          return (
                                                            <li key={parentName}>
                                                              <span className="font-bold">{parentName}:</span> {moduleNames[parentName].join(', ')}
                                                            </li>
                                                          )
                                                        })
                                                        }
                                                      </ul>
                                                    </>
                                                  )
                                                })
                                              }
                                            }}   //||  (formik.values.isFromSourceAccount && formik.values.isDataMigrationEnabled)
                                            className={`${childObject.isRequired === true ? "h-4 w-4 rounded border-red-500 text-gray-800 focus:ring-gray-800" : "h-4 w-4 rounded border-gray-300 text-gray-800 focus:ring-gray-800"}`} />
                                        </div>
                                        <div className="ml-1 text-sm leading-6">
                                          <label className={`${childObject.isRequired === true ? "font-medium text-red-500" : "font-medium text-gray-900"}`}>{childObject.name}</label>
                                        </div>
                                      </div>
                                    </li>)
                                  ))
                                  }
                                </ul>
                              </div>
                            </div>
                          </div>
                        ))
                      }
                    </ul>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Popup
        modalState={[openModal, setOpenModal]}
        isConfirm={false}
        bodyClass="p-0"
        size="2xl"
        fullHeader={<div className="flex justify-center item-center"><svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 26 26"
          strokeWidth={1.5}
          stroke="currentColor"
          className="mr-2 h-9 w-9 text-red-400 dark:text-red-200"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
          />
        </svg>
          <h5>Dependency List</h5></div>}
        content={
          <>
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400 ">
              <div>
                <ul>
                  <table
                    className="min-w-full divide-y divide-gray-300">
                    <thead className="bg-gray-50">
                      <tr>
                        <th scope="col"
                          className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                          Select Required Fields</th>
                      </tr>
                    </thead>
                    <tbody
                      className="divide-y divide-gray-200 bg-white">
                      {dependencyList.length > 0 && dependencyList.map(object => (
                        <tr>
                          <td
                            className=" capitalize whitespace-nowrap px-6 py-4 text-sm text-gray-500  text-left">
                            <li key={object.config_module}>{`${(object.config_module).split(' ')
                              .join('').replace(/_/g, ' ')
                              .toLowerCase()}
                              ${object.config_name.split(' ')
                                .join('').replace(/_/g, ' ')
                                .toLowerCase()} Required for 
                                ${object.needed_config_module.split(' ')
                                .join('').replace(/_/g, ' ')
                                .toLowerCase()} 
                                  ${object.needed_config_name.split(' ')
                                .join('').replace(/_/g, ' ')
                                .toLowerCase()}`}</li>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </ul>
              </div>
            </h3>
          </>
        }
      />
    </section>
  )
}